module.exports = __webpack_public_path__ + "img/ar.e261ef92.svg";